import { configureStore } from "@reduxjs/toolkit";
import  StepSlice  from "./Steps"

const store = configureStore({
    reducer: {
        step :StepSlice.reducer
    }
})

export default store